import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Report, ReportParams } from '../reports.model';
import {SystemService} from '../../../services/system.service';
import {Entity} from '../../../pages/product/product.model';


@Component({
    selector     : 'report-form-dialog',
    templateUrl  : './report-form.component.html',
    styleUrls    : ['./report-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ReportFormDialogComponent // implements OnInit
{


    /**
     * Constructor
     *
     * @param {MatDialogRef<ActivityFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     * @param _systemService
     */
    constructor(
        public matDialogRef: MatDialogRef<ReportFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        public _systemService: SystemService
        // public systemService:SystemService
    )
    {
        // Set the defaults
        this.action = _data.action;
        this.reports = _data.reports;
        this.reportParam = _data.params;
        this.enabled = false;

        this.clients = this._systemService.clients;
        this.users = this._systemService.users;
        this.projectStatuses = this._systemService.getStringArray('project.status');

        // if ( this.action === 'edit' )
        // {
        this.dialogTitle = 'Generar Reporte';
        // this.activity = _data.activity;
        // }
        // else
        // {
        //     this.dialogTitle = 'Nueva Actividad';
        //     //this.activity = new Activity({});
        // }

        this.reportForm = this.createReportForm();
    }

    action: string;
    // activity: Activity;
    reportForm: FormGroup;

    dialogTitle: string;
    reportParam: ReportParams;
    reports: Report[];
    clients: Entity[];
    users: Entity[];
    projectStatuses: string[];
    fromTo: boolean;
    noDates: boolean;
    inCharge: boolean;
    client: boolean;
    status: boolean;
    selected: boolean;

    // ngOnInit(): void {
    //
    // }
    enabled: boolean;

    noExtensionName(name: string): string{
        return name == null ? null : name.substring(0, name.lastIndexOf('.'));
    }

    /**
     * Create activity form
     *
     * @returns {FormGroup}
     */
    createReportForm(): FormGroup
    {
        return this._formBuilder.group({
            // id              : [this.activity.id],
            noDates       : [this.reportParam.noDates],
            from          : [this.reportParam.from],
            to            : [this.reportParam.to],
            template      : [this.reportParam.template],
            client        : [this.reportParam.client],
            status        : [this.reportParam.status],
            inCharge      : [this.reportParam.inCharge],
            selected      : [this.reportParam.selected]
        });
    }

    templateChanged(report: Report, event: any): void{
        if (event.isUserInput) {
            const params: string = report.params || '';
            this.inCharge = params.includes('inCharge');
            this.status = params.includes('status');
            this.fromTo = params.includes('fromTo');
            this.client = params.includes('client');
            this.noDates = params.includes('noDates');
            this.selected = params.includes('selected');
            if (this.selected) {
                this.reportForm.get('selected').setValue(true);
            }
            // this.ngOnInit();
        }
    }

    setDisabled(checked: boolean): void {
        if (checked) {
            this.reportForm.get('from').disable();
            this.reportForm.get('to').disable();
        }else{
            this.reportForm.get('from').enable();
            this.reportForm.get('to').enable();
        }
    }
}
